import { MedicalNotesScreen } from "app/screens/residents/show/MedicalNotesScreen";

export default function MedicalNotesPage() {
  return <MedicalNotesScreen />;
}
